<template>

<form
  class="mx-auto col-sm-8"
  @submit.prevent
>
  <div class="form-group" :class="{ 'has-error': errors.has('name') }">
    <label for="name">{{ $t('name') }}</label>
    <input
      type="text"
      id="name"
      name="name"
      class="form-control"
      :placeholder="$t('type_name')"
      v-model="vehicleBrand.name"
      v-validate="'required'"
      @input="upper"
    >
    <small v-show="errors.has('name')" class="form-text text-muted">
      {{ errors.first('name') }}
    </small>
  </div>

  <div class="form-group row">
    <div class="col-sm-4 col-sm-offset-2">
      <LoaderButton
        @click="save"
      >
        {{ $t('save') }}
      </LoaderButton>
    </div>
  </div>
</form>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'

export default {
  name: 'VehicleBrandForm',
  components: {
    LoaderButton
  },
  props: {
    vehicleBrand: {
      type: Object,
      default: () => ({
        id: undefined,
        name: ''
      })
    }
  },
  methods: {
    ...mapActions('vehiclebrands', [
      'create',
      'edit',
      'cleanState'
    ]),

    async save (evt, done) {
      const valid = await this.$validator.validateAll()

      if (!valid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }

      const { id } = this.vehicleBrand

      const promise = id ? this.edit({ id, data: this.vehicleBrand }) : this.create(this.vehicleBrand)

      const result = await promise

      if (result) this.$router.push({ name: 'listvehiclebrands' })
    },

    upper() {
      this.vehicleBrand.name = this.vehicleBrand.name.toUpperCase()
    }
  },
  destroyed () {
    this.cleanState()
  }
}
</script>
